import { TNavigateToSchedulerCommand } from './commands/navigate_to_scheduler_command';
import { IState } from 'angular-ui-router';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export const standAloneSchedulerState: IState = {
  url: 'standalonescheduler/',
  resolve: {
    redirectToScheduler: (navigateToSchedulerCommand: TNavigateToSchedulerCommand, _Account: ng.IPromise<IQuery>) =>
      navigateToSchedulerCommand()
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/standalone_scheduler/state_configuration.ts